/**
 * Mobile debug console — eruda CDN, lazy load.
 * Aktywacja: ?debug=1 w URL LUB localStorage 'rf-debug' === '1'.
 * Po aktywacji eruda persistuje przez localStorage (przeżywa F5).
 *
 * Po co: na iPhone Safari nie da się otworzyć DevTools bez Maca. Eruda
 * wstrzykuje console / network / elements / storage panel jako overlay.
 */

const STORAGE_KEY = 'rf-debug';
const ERUDA_CDN = 'https://cdn.jsdelivr.net/npm/eruda@3.0.1/eruda.js';

export function shouldEnableDebug(): boolean {
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get('debug') === '1') {
      localStorage.setItem(STORAGE_KEY, '1');
      return true;
    }
    if (url.searchParams.get('debug') === '0') {
      localStorage.removeItem(STORAGE_KEY);
      return false;
    }
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export async function initDebugConsole(): Promise<void> {
  if (!shouldEnableDebug()) return;
  if ((window as unknown as { eruda?: unknown }).eruda) return;
  await new Promise<void>((resolve, reject) => {
    const s = document.createElement('script');
    s.src = ERUDA_CDN;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('eruda load failed'));
    document.head.appendChild(s);
  }).catch((err) => console.warn('[debug] eruda CDN failed:', err));
  const eruda = (window as unknown as { eruda?: { init: () => void } }).eruda;
  if (eruda) {
    eruda.init();
    console.info('[debug] eruda mobile console aktywny — kliknij ikonę żeby otworzyć');
  }
}

export function disableDebug(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch { /* ignore */ }
  window.location.reload();
}
